module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAACXBIWXMAAAsSAAALEgHS3X78AAAAw0lEQVQ4jcWTwQ3CMBAEB8Q/lEAHpAMoIR0AsmSXQUrIN5EiKIEOQgmUQAtUEHTSgULw4Uce7Mv2ede7Z3vW9z1TMJ/EBhZWwfmQAwVwa5v6Yu2LRlDyFch06dA29Tkm8BUhQhacnA/7pIBB/inyjuB8WEleoAKWQD7YJ+vSh24cZ+hgb5w8RmVGUBTqYIyX/SwlsFaRsm3qrY4lzi5mx3pIckrnfCiBO7Cx8pgPSXFM1D8cSJcfKYLcwnDy/880TQB4AkrUMqvgDrraAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/img/landing/mail.png
// module id = qiI9
// module chunks = 1